<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate qualification-id="" submit-form user-id=""
        education-id="">
    <div class="row">

      <div class="col-lg-9 col-md-9 col-sm-12">
        <BaseInput v-model="formData.description"
                   label="Art"/>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-12">
        <span>Art</span>
        <div class="row">
          <BaseRadio
              v-model="formData.type"
              label="Ja"
              name="type"
              id="1"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>

          <BaseRadio
              v-model="formData.type"
              label="Nein"
              name="type"
              id="0"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>Zeitraum</p>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <div class="row">
          <div class="col-lg-4 col-md-4 col-6">
            <Datepicker
                label="Startdatum"
                position="down"
                :required="true"
                v-model="formData.startDate"
                :validation="v$.startDate"
                :messages="v$.startDate.required.$message"/>
          </div>
          <div class="col-lg-4 col-md-4 col-6">
            <Datepicker
                label="Enddatum"
                position="down"
                :required="true"
                v-model="formData.endDate"
                :validation="v$.endDate"
                :messages="v$.endDate.required.$message"/>
          </div>
          <div class="col-lg-4 col-md-4 col-6">
            <BaseNumber
                label="UE-Anzahl"
                v-model="formData.ueNumber"/>
          </div>
        </div>
      </div>
      <div class="col-3">
        <p>Vereinbarung liegt vor</p>
        <div class="row">
          <BaseRadio
              v-model="formData.agreementIsInPlace"
              label="Ja"
              name="agreementIsInPlace"
              id="1"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>

          <BaseRadio
              v-model="formData.agreementIsInPlace"
              label="Nein"
              name="agreementIsInPlace"
              id="0"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center w-100 mt-3">
      <SaveButton
          :label="$t('general.button.save')"
          :loading="isSubmitting"/>
    </div>
  </form>
</template>

<script setup>
import userService from '@/api/User';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { computed, defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  userId: {
    type: [ String, Number ],
    required: true,
  },
  educationId: {
    type: [ String, Number ],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  userId: '',
  description: '',
  type: '0',
  startDate: '',
  endDate: '',
  ueNumber: '',
  agreementIsInPlace: '0',
});

const rules = computed(() => {
  return {
    startDate: requiredRule(t),
    endDate: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.educationId) {
      await userService.putFurtherEducation(+props.userId, props.educationId, formData.value);
    } else {
      await userService.postFurtherEducation(+props.userId, formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getEducationData(educationId) {
  try {
    const { data }           = await userService.getSingleFurtherEducation(+educationId);
    const type               = String(data.data.type);
    const agreementIsInPlace = String(data.data.agreementIsInPlace);

    formData.value = {
      ...data.data,
      type: type,
      agreementIsInPlace: agreementIsInPlace,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (props.educationId) {
    await getEducationData(props.educationId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>